function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Chat Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M16.3056,4 C17.7938627,4 19.0006,5.20597782 19.0006,6.694 L19.0006,12.306 C19.0006,13.7940222 17.7938627,15 16.3056,15 L16.0006,15 L16.0006,18.5 L11.3339333,15 L7.6946,15 C6.9233356,15 6.21409374,14.7483224 5.83533292,14.2315938 L6.64186708,13.6404062 C6.79821531,13.8537061 7.21047999,14 7.6946,14 L11.6672667,14 L15.0006,16.5 L15.0006,14 L16.3056,14 C17.2417189,14 18.0006,13.2415965 18.0006,12.306 L18.0006,6.694 C18.0006,5.75840355 17.2417189,5 16.3056,5 L15.5006,5 L15.5006,4 L16.3056,4 Z M11.306,0 C12.7941424,0 14,1.20585763 14,2.694 L14,8.306 C14,9.79414237 12.7941424,11 11.306,11 L7.66666667,11 L3,14.5 L3,11 L2.695,11 C1.20673726,11 -8.8817842e-16,9.79402218 -8.8817842e-16,8.306 L-8.8817842e-16,2.694 C-8.8817842e-16,1.20597782 1.20673726,0 2.695,0 L11.306,0 Z M11.306,1 L2.695,1 C1.75888113,1 1,1.75840355 1,2.694 L1,8.306 C1,9.24159645 1.75888113,10 2.695,10 L4,10 L4,12.5 L7.33333333,10 L11.306,10 C12.2418576,10 13,9.24185763 13,8.306 L13,2.694 C13,1.75814237 12.2418576,1 11.306,1 Z M6.4999,5.9224 C6.77604237,5.9224 6.9999,6.14625763 6.9999,6.4224 C6.9999,6.69854237 6.77604237,6.9224 6.4999,6.9224 L3.5179,6.9224 C3.24175763,6.9224 3.0179,6.69854237 3.0179,6.4224 C3.0179,6.14625763 3.24175763,5.9224 3.5179,5.9224 L6.4999,5.9224 Z M9.5003,3 C9.77644237,3 10.0003,3.22385763 10.0003,3.5 C10.0003,3.77614237 9.77644237,4 9.5003,4 L3.5003,4 C3.22415763,4 3.0003,3.77614237 3.0003,3.5 C3.0003,3.22385763 3.22415763,3 3.5003,3 L9.5003,3 Z",
  id: "chat-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "chat-Icon/Global/Chat",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "chat-Swatches/DarkGreen",
  transform: "translate(2.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "chat-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#chat-path-1"
})));

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.1ac1415d.svg";
export { ForwardRef as ReactComponent };